import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { usePersonalizationSettings, useSubtitleState } from '../../../providers/DataProvider/DataContext';
import { InfoIcon } from '../../InfoIcon/InfoIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export const SubtitleLabel = () => {
  const {
    t
  } = useTranslation();
  const {
    isActive
  } = usePersonalizationSettings();
  const {
    showSubtitle
  } = useSubtitleState();
  return /*#__PURE__*/_jsx(Fragment, {
    children: (!isActive || showSubtitle) && /*#__PURE__*/_jsx(InfoIcon, {
      text: t('global.subtitleShorthand')
    })
  });
};